import type { SVGProps } from 'react';
const SvgWbTwighlight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#wb_twighlight_svg__a)">
      <path
        fill="currentColor"
        d="m16.954 8.66 2.12-2.12 1.415 1.414-2.13 2.12-1.405-1.414ZM17.9 14c-.5-2.85-2.95-5-5.9-5s-5.45 2.15-5.9 5h11.8ZM2 16h20v4H2v-4Zm9-12h2v3h-2V4ZM3.54 7.925 4.954 6.51l2.122 2.122-1.415 1.415L3.54 7.925Z"
      />
    </g>
    <defs>
      <clipPath id="wb_twighlight_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWbTwighlight;
